import React from "react";
import { Helmet } from "react-helmet";

export default function SEO() {
  const orgJsonLd = {"@context":"https://schema.org","@type":"Organization","name":"Beyond Box","url":"https://www.beyondbox.example","logo":"https://www.beyondbox.example/logo.png"};
  const faqJsonLd = {"@context":"https://schema.org","@type":"FAQPage","mainEntity":[
    {"@type":"Question","name":"Do you supply SS304 grade?","acceptedAnswer":{"@type":"Answer","text":"Yes, we primarily manufacture in SS304 with optional SS202 for budget applications."}},
    {"@type":"Question","name":"Do you offer custom finishes?","acceptedAnswer":{"@type":"Answer","text":"Yes — PVD, mirror, hairline, brushed, and bespoke colors on request."}}
  ]};
  return (
    
    
    <Helmet>
  <html lang="en" />
  <title>Beyond Box — SS Profiles, Decorative Sheets & Luxury Finishes</title>
  <meta name="description" content="Premium stainless steel T/U/Transition/Tile Edge/Corner/Solid/Stair Nosing profiles and SS decorative sheets in SS304 grade." />
  <meta property="og:title" content="Beyond Box — SS Profiles & Decorative Sheets" />
  <meta property="og:description" content="Architectural SS profiles and decorative sheets for luxury interiors." />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="/og.jpg" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Beyond Box — SS Profiles & Decorative Sheets" />
  <meta name="twitter:description" content="Architectural SS profiles and decorative sheets for luxury interiors." />
  <meta name="twitter:image" content="/og.jpg" />
  <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
  <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
  <link rel="canonical" href="https://www.beyondbox.example/" />
</Helmet>

    
  )
}
